<div class="jw-modal">
    <div class="jw-modal-body modalDayHeader centerTxt">
        <h1>      <img
          *ngIf="todaySun"
          src="../../../calendar/assets/img/sunTodayCalendar.png"
          alt="Today Sun"
          height="40"
          width="40"
          class="moon"
        /> <span *ngIf="todaySun">Today is</span> {{modalMonthName}} {{modalDate}}  <span class="BOS">{{modalSignIcon}}</span></h1>
        <h2></h2>

        <img
        *ngIf="fullMoon || fullMoon2 "
        src="../../../calendar/assets/img/fullmoon.png"
        alt="Full Moon"
        height="40"
        width="40"
        class="moon"
      />
      <img
      *ngIf="newMoon || newMoon2 "
        src="../../../calendar/assets/img/newmoon.png"
        alt="New Moon"
        height="40"
        width="40"
        class="moon"
      />
      <img
        *ngIf="
          firstQMoon ||
          firstQMoon2
        "
        src="../../../calendar/assets/img/firstqmoon.png"
        alt="First Quarter Moon"
        height="40"
        width="40"
        class="moon"
      /> 
      <img
        *ngIf="
        lastQMoon ||
        lastQMoon2
        "
        src="../../../calendar/assets/img/lastqmoon.png"
        alt="Last Quarter Moon"
        height="40"
        width="40"
        class="moon"
      />
      <p>{{message}}</p>         

    
        <ng-content></ng-content>
    </div>
</div>
<div class="jw-modal-background"></div>




